import { useEffect, useState } from 'react'
import axios from 'axios'
import NavbarTopAdmin from './components/navbarTopAdmin'
import NavbarBottomAdmin from './components/navbarBottomAdmin'
import AuthProvider from '../Authentication/authProvider'

function CheckImg() {
    const [foto, setFoto] = useState([])//array foto non utilizzate
    const [video, setVideo] = useState([])//array video non utilizzate
    const [fotoChecked, setFotoChecked] = useState([])//array nomi di foto cliccate

    function handleInputChangeImg(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value
        inputValue === true && setFotoChecked(fotoChecked.concat(name))
        inputValue === false && setFotoChecked(fotoChecked.filter(elem => elem !== name))
    }

    async function removeImg() {
        try {
            fotoChecked.forEach(elem => {
                if (elem.substring(0, 6) === 'video_') {//rimozione parola 'video' 
                    axios.delete(`/delete-video/${elem.replace("video_", "")}`)
                } else axios.delete(`/delete-img/${elem}`, { data: { folder: '' } })
            })
            setFoto(foto.filter(x => !fotoChecked.includes(x)))
            setVideo(video.filter(x => !fotoChecked.includes('video_' + x)))
            setFotoChecked([])
            const ty = document.getElementsByClassName('imgCheckbox')
            for (let r = 0; r < ty.length; r++) {
                ty[r].checked = false
            }
        } catch (err) { console.log(err) }
    }

    useEffect(() => {
        axios.post('/checkImg').then(res => {
            async function vd() {
                await axios.get('/list-videos').then(fv => {
                    const obj = fv.data.files
                    let bn = []
                    for (let x = 1; x < obj.length; x++) {
                        const e = obj[x].replace("video/", (""))
                        bn.push(e)
                    }
                    const nm = bn.filter(x => !res.data.includes(x))
                    setVideo(nm)
                })
            }
            async function im() {
                await axios.get('/list-images').then(fg => {
                    const obm = fg.data.files; const obm2 = fg.data.files2
                    const evt_news = obm.concat(obm2)
                    setFoto(evt_news.filter(x => !res.data.includes(x)))
                })
            }
            vd(); im()
        })
    }, [])

    // useEffect(() => { console.log('video:', video) }, [video])

    return (<>
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        <AuthProvider />
        <br /><br />
        <div className='container'>
            <h5 style={{ margin: '3rem 0 1rem 0' }}>IMMAGINI IN CLOUD NON UTILIZZATE</h5>
            {!foto && <p>Tutte le foto sono utilizzate.</p>}
            {foto &&
                <div>
                    {fotoChecked.length !== 0 &&
                        <button className='btn btn-danger' onClick={removeImg} style={{ position: 'fixed', left: '60%', top: '5em' }}>
                            <b>❌ ELIMINA</b>
                        </button>
                    }
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Photo</th><th className='thDesk'>Name</th><th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {foto.map((elem, index) => (
                                <tr key={index}>
                                    <td>
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} style={{ maxHeight: '80px', maxWidth: '150px' }} />
                                    </td>
                                    <td className='thDesk'>{elem}</td>
                                    <td><input
                                        id={elem}
                                        className='imgCheckbox'
                                        name={elem}
                                        defaultChecked={false}
                                        type="checkbox"
                                        onChange={handleInputChangeImg} />
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>
                </div>
            }
            {video &&
                <div>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Video</th><th className='thDesk'>Name</th><th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {video.map((elem, index) => (
                                <tr key={index}>
                                    <td>
                                        <video src={`https://leuro-bucket.s3.amazonaws.com/video/${elem}`} controls style={{ maxHeight: '100px', width: '150px' }} />
                                    </td>
                                    <td className='thDesk'>{elem}</td>
                                    <td><input
                                        name={'video_' + elem}
                                        className='imgCheckbox'
                                        defaultChecked={false}
                                        type="checkbox"
                                        onChange={handleInputChangeImg} />
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    </>)
}
export default CheckImg